import { Author } from '../../api/Author';
import { Tag } from '../../api/Tag';

export const sortTagsByName = (tags: Tag[]): Tag[] =>
  [...tags].sort((a, b) => a.name.localeCompare(b.name));

export const sortAuthorsByFullName = (authors: Author[]): Author[] =>
  [...authors].sort((a, b) => {
    const nameA = `${a.first_name || ''} ${a.name || ''}`.trim();
    const nameB = `${b.first_name || ''} ${b.name || ''}`.trim();
    return nameA.localeCompare(nameB);
  });
